(ns frontend.test.validation.immediate
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [frontend.test.validation.model :as m]
   [ui.components.button.view :as button]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]
   [common.util :as cu]))

(defn field-component
  [ctx {:keys [attribute label data-type mandatory?
               class validate-at-start?] :as _defs}]
  (r/with-let [local-state (r/atom {:dirty? false})]
    (let [value @(rf/subscribe [m/entity-value ctx])
          errors @(rf/subscribe [m/entity-value-errors ctx])
          display-errors? (or validate-at-start?
                              (:dirty? @local-state))
          #_#_errors "test"]
      (prn ">input" attribute value)
      [:div
       {:class (uu/cm "flex flex-col")}
       [labelled-input/view
        {:label label
         :mandatory? mandatory?
         :error (when display-errors?
                  (seq errors))
         :class class
         :on-error! (fn [& e]
                    ;;TODO how to clear the input local state?
                    ;; should we display error-message about failed date-parsing?
                    ;;  where to save that error? when to clear?
                    ;;
                      (prn ">error" e))
         :value value
           ;;:on-focus on-focus
           ;;:on-blur on-blur
         :on-blur (fn [args]
                    (swap! local-state assoc :dirty? true)
                    (prn ">on-blur" args))
         :on-change (fn [new-val]
                      (swap! local-state assoc :dirty? true)
                      (prn ">on-change" new-val)
                      (rf/dispatch-sync
                       [m/update-value
                        (assoc ctx
                               :value new-val)]))
       ;;:entity-types
         :create! (fn [query]
                    (prn "create!" query))
         :data-type data-type
           ;;:dom-id dom-id
         }]
       [:div
        {:class (uu/cm "text-[12px] text-danger-light-text-accent")}
        ;;TODO here entity-creator if creatable ref field?
        (when display-errors?
          (some-> errors first :error-message))
        #_(for [{:keys [error-message error-kw]} errors]
            ^{:key (str error-kw)}
            [:span error-message])]])))

(defn attr-label
  [ctx a]
  (let [{:keys [label]} (get m/attribute-defs-by-attribute a)]
    label))

(defn footer
  [ctx]
  (let [validations @(rf/subscribe [m/validate-all ctx])
        disabled? (not (cu/blank-value? validations))]
    (prn ">validations" validations)
    [:div
     {:class (uu/cm "py-4")}
     [button/primary-solid
      {:disabled? disabled?
       :tooltip (when (seq validations)
                  (->> validations
                       (mapcat (fn [[attribute error-msgs]]
                                 (let [msgs (->> error-msgs
                                                 (mapv :error-message)
                                                 (filterv string?)
                                                 (mapv (fn [s]
                                                         (str (attr-label ctx attribute)
                                                              ": " s))))]
                                   msgs)))
                       ;;(mapv :error-message)
                       ;;(filterv string?)
                       (string/join ", ")))
       :on-click
       (fn [_]
         (prn ">save")
         #_(rf/dispatch [m/create-connector
                         (assoc ctx
                                :selected selected
                                :source-id (if (= direction :source)
                                             map-profile-id
                                             selected)
                                :target-id (if (= direction :source)
                                             selected
                                             map-profile-id)
                                :type connector-type)]))}
      (loc/tr :save)]]))

(defn view
  []
  (r/with-let [ctx {:ident :immediate
                    :entity-id 1111111111}
               _ (prn ">immediate-creation/mount")]
    [:div
     {:class (uu/cm "flex flex-col gap-1")}
     [button/sm-danger-solid
      {:class (uu/cm "w-20")
       :on-click
       (fn [_]
         (rf/dispatch [m/clear-state
                       ctx]))}
      "Clear state"]
     [:div
      {:class (uu/cm "text-lg")}
      "Validate on each keydown"]
     (doall
      (for [{:keys [attribute] :as def} m/attribute-defs
            :let [ctx (assoc ctx :attribute attribute)]]
        ^{:key (str attribute)}
        [field-component ctx def]))
     [footer ctx]]
    (finally
      (prn ">immediate-unmount"))))
